import React, { useState, useEffect } from 'react';
import { Container, Form, Row, Col } from 'react-bootstrap';
import { mapEpisodeValueToMeta } from '../../DataMapper/helpers';

const InputForm = ({
  editable,
  titles,
  episode,
  handleInputChange,
  clinic,
}) => {
  // add ?. to access data with falldown empty array to avoid throw error
  const [localClinicMeta, setLocalClinicMeta] = useState(() =>
    mapEpisodeValueToMeta(episode?.details || {}),
  );

  // Update local state when prop changes
  useEffect(() => episode?.details || {}, [episode?.details]);

  const localHandleInputChange = (e) => {
    const { name, value } = e.target;

    const updatedMeta = [...localClinicMeta];
    const metaIndex = updatedMeta.findIndex((meta) => meta.meta_name === name);

    if (metaIndex !== -1) {
      updatedMeta[metaIndex] = {
        ...updatedMeta[metaIndex],
        meta_value: value,
      };
    } else {
      updatedMeta.push({ meta_name: name, meta_value: value });
    }
    setLocalClinicMeta(updatedMeta);

    let temp = Object.assign({}, JSON.parse(JSON.stringify(clinic)));
    temp.clinic_meta = updatedMeta;
    handleInputChange(temp); //update parent state
  };

  return (
    <Container className="inputForm">
      <div>
        {titles &&
          titles[0].data.map((titleObject, index) => {
            const matchingMeta = localClinicMeta.find(
              (meta) => meta.meta_name === titleObject.title,
            );

            return (
              <Form.Group as={Row} className="mb-3" key={index}>
                <Form.Label column sm={4} style={{ wordWrap: 'break-word' }}>
                  <span className="labelBold">{titleObject.title}</span>
                </Form.Label>
                <Col sm={8} style={{ paddingTop: '6px' }}>
                  {!editable && (
                    <Form.Label className="labelSimple">
                      {matchingMeta ? matchingMeta.meta_value : '-'}
                    </Form.Label>
                  )}
                  {editable && (
                    <Form.Control
                      type="text"
                      placeholder="Enter details..."
                      name={titleObject.title} // Set name to help with localHandleInputChange
                      defaultValue={matchingMeta ? matchingMeta.meta_value : ''}
                      onBlur={localHandleInputChange}
                    />
                  )}
                </Col>
              </Form.Group>
            );
          })}
      </div>
    </Container>
  );
};

export { InputForm };
